import GetGiftBookReadButton from './getGiftBookReadButton'
import GetGiftReadInstructions from './getGiftReadInstructions'

export default function GetGiftPresentOverlay({ canRead, email, product, accessUrl, keyColor }) {
  return (canRead ?
    <GetGiftBookReadButton accessUrl={ accessUrl } keyColor={ keyColor } /> :
    <GetGiftReadInstructions product={ product } email={ email } />
  )
}
